














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CardSliderNavDots extends Vue {
  @Prop({ type: Array, default: () => [] })
  public dots!: Array<any>;

  @Prop({ type: Number, default: 0 })
  public active!: number;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/slider/images/components/CardSliderNavDots.vue